import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  styleUrls: ['./sticky-footer.component.sass']
})
export class StickyFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
